<template>
  <div>
    <a-card :bordered="false">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="代收测试">
          <pay-in-test />
        </a-tab-pane>
        <a-tab-pane key="2" tab="代付测试">
          <pay-out-test />
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script>
import PayInTest from './components/PayInTest'
import PayOutTest from './components/PayOutTest'

export default {
  name: 'ChannelTestPage',
  components: {
    PayInTest,
    PayOutTest
  }
}
</script>

<style lang="less" scoped>
</style>
